import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminStore } from '../state/admin.store';
import { adminAuthApi } from '../services/admin.api';

/**
 * AdminProtectedRoute - Protects admin routes by checking authentication
 *
 * Redirects to /admin/login if the admin is not authenticated
 */
export const AdminProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAdminStore();
  const [isChecking, setIsChecking] = useState(true);
  const [hasToken, setHasToken] = useState(false);

  useEffect(() => {
    // Check if admin has valid token and sync with apiClient
    const checkAuth = () => {
      const hasValidToken = adminAuthApi.isAuthenticated();
      setHasToken(hasValidToken);

      // Sync admin tokens with apiClient
      if (hasValidToken) {
        const adminAccessToken = adminAuthApi.getAccessToken();
        const adminRefreshToken = adminAuthApi.getRefreshToken();

        if (adminAccessToken && adminRefreshToken) {
          // Ensure apiClient has the admin tokens
          adminAuthApi.setTokens(adminAccessToken, adminRefreshToken);
        }
      }

      setIsChecking(false);
    };

    checkAuth();
  }, []);

  // Show loading while checking
  if (isChecking) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  // Redirect if not authenticated
  if (!isAuthenticated && !hasToken) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
};

export default AdminProtectedRoute;
